import React from 'react';
import logo from '../../logo-gita-1.png';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './footer.styles.css';

const Footer = () => (
    <Container fluid className="my-footer">
        <Row className="d-flex justify-content-center text-center">
            <Col lg={{ order: 2 }} className="footer-right">
            <img src={logo} alt="gpersable-logo" draggable="false" className="logo-footer" />
            </Col>
            <Col lg={{ order: 1 }}>
            <p>Designed and built by Gita Permatasari Sujatmiko</p>
            <p className="ps">Parallax stars background by Saransh Sinha</p>
        {/* <Row className="d-flex justify-content-center text-center"> */}
            <p>2021</p>
            </Col>
        </Row>
    </Container>
);

export default Footer;